/**
 * Harvest Mate - OEM Connection API
 *
 * Contact: servicedesk@clevvi.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { FarmLink } from '../model/farm-link';
// @ts-ignore
import { FarmsList } from '../model/farms-list';
// @ts-ignore
import { LinkFarmRequest } from '../model/link-farm-request';
// @ts-ignore
import { Provider } from '../model/provider';
// @ts-ignore
import { UnlinkFarmResponse } from '../model/unlink-farm-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class OemFarmsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Link an OEM farm to a Harvest Mate farm (SRA003-440).
     * Inserts (or idempotently re-points) a row in &#x60;oem_farm_links&#x60; joining &#x60;(provider, oem_farm_id)&#x60; to the requested &#x60;farm_id&#x60; — the farm-level sibling of the field link. A partial unique index on &#x60;(provider, oem_farm_id)&#x60; restricted to &#x60;status&#x3D;\&#39;active\&#39;&#x60; keeps one active link per OEM farm; re-link with the same body re-points the active row (still 201).  Cross-type validation (&#x60;farm→farm&#x60; only): a &#x60;farm_id&#x60; that does not name an existing, non-deleted farm is rejected with 400 &#x60;invalid_link_target&#x60;. The caller must also harvest the target farm (a &#x60;harvester_crop_assignments&#x60; row joining a group they own to a block in that farm), else 403 &#x60;farm_not_assigned&#x60;.  DB-only — works for both providers regardless of any OEM base-URL gate. 
     * @endpoint post /oem-connection/{provider}/farms/{oem_farm_id}/link
     * @param provider OEM provider key.
     * @param oemFarmId OEM-issued farm identifier.
     * @param linkFarmRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public linkOemFarm(provider: Provider, oemFarmId: string, linkFarmRequest: LinkFarmRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FarmLink>;
    public linkOemFarm(provider: Provider, oemFarmId: string, linkFarmRequest: LinkFarmRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FarmLink>>;
    public linkOemFarm(provider: Provider, oemFarmId: string, linkFarmRequest: LinkFarmRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FarmLink>>;
    public linkOemFarm(provider: Provider, oemFarmId: string, linkFarmRequest: LinkFarmRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling linkOemFarm.');
        }
        if (oemFarmId === null || oemFarmId === undefined) {
            throw new Error('Required parameter oemFarmId was null or undefined when calling linkOemFarm.');
        }
        if (linkFarmRequest === null || linkFarmRequest === undefined) {
            throw new Error('Required parameter linkFarmRequest was null or undefined when calling linkOemFarm.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cognito) required
        localVarHeaders = this.configuration.addCredentialToHeaders('cognito', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/oem-connection/${this.configuration.encodeParam({name: "provider", value: provider, in: "path", style: "simple", explode: false, dataType: "Provider", dataFormat: undefined})}/farms/${this.configuration.encodeParam({name: "oemFarmId", value: oemFarmId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/link`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FarmLink>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: linkFarmRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List OEM farms visible via the contractor\&#39;s connected org.
     * Returns the OEM-side farms enumerable through the contractor\&#39;s active OAuth connection — the read endpoint that drives the FE farm-linker (the farm-level sibling of &#x60;GET .../fields&#x60;, SRA003-446). Deere sources from &#x60;GET .../organizations/{orgId}/farms&#x60;; CNH sources from the company overview &#x60;GET /v1/companies/{companyId}/overview&#x60;, flattening its grower→farm tree (Farm Setup product, granted). Each entry carries &#x60;linked_farm_id&#x60; when the contractor has already linked that OEM farm to a Harvest Mate farm via the POST endpoint below.  A connected org with no farms yet (Deere 404 / empty CNH overview) returns 200 with an empty array. 
     * @endpoint get /oem-connection/{provider}/farms
     * @param provider OEM provider key.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listOemFarms(provider: Provider, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<FarmsList>;
    public listOemFarms(provider: Provider, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<FarmsList>>;
    public listOemFarms(provider: Provider, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<FarmsList>>;
    public listOemFarms(provider: Provider, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling listOemFarms.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cognito) required
        localVarHeaders = this.configuration.addCredentialToHeaders('cognito', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/oem-connection/${this.configuration.encodeParam({name: "provider", value: provider, in: "path", style: "simple", explode: false, dataType: "Provider", dataFormat: undefined})}/farms`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FarmsList>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Unlink an OEM farm (soft-archive) (SRA003-440).
     * Soft-archives the active &#x60;oem_farm_links&#x60; row by setting &#x60;status&#x3D;\&#39;archived\&#39;&#x60; rather than deleting it — mirrors the field unlink and preserves history. Returns 200 with a typed body. 
     * @endpoint delete /oem-connection/{provider}/farms/{oem_farm_id}/link
     * @param provider OEM provider key.
     * @param oemFarmId OEM-issued farm identifier.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public unlinkOemFarm(provider: Provider, oemFarmId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<UnlinkFarmResponse>;
    public unlinkOemFarm(provider: Provider, oemFarmId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<UnlinkFarmResponse>>;
    public unlinkOemFarm(provider: Provider, oemFarmId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<UnlinkFarmResponse>>;
    public unlinkOemFarm(provider: Provider, oemFarmId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (provider === null || provider === undefined) {
            throw new Error('Required parameter provider was null or undefined when calling unlinkOemFarm.');
        }
        if (oemFarmId === null || oemFarmId === undefined) {
            throw new Error('Required parameter oemFarmId was null or undefined when calling unlinkOemFarm.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cognito) required
        localVarHeaders = this.configuration.addCredentialToHeaders('cognito', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/oem-connection/${this.configuration.encodeParam({name: "provider", value: provider, in: "path", style: "simple", explode: false, dataType: "Provider", dataFormat: undefined})}/farms/${this.configuration.encodeParam({name: "oemFarmId", value: oemFarmId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/link`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<UnlinkFarmResponse>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
